import Shimmer from "@/components/base/Shimmer";

const MOCK_BUBBLES = [
  { side: "left" as const, w: 45 },
  { side: "left" as const, w: 70 },
  { side: "right" as const, w: 55 },
  { side: "left" as const, w: 35 },
  { side: "right" as const, w: 65 },
  { side: "left" as const, w: 80 },
  { side: "right" as const, w: 40 },
  { side: "left" as const, w: 50 },
];

export default function ChatWindowShimmer() {
  return (
    <div className="flex-1 flex flex-col min-h-0 bg-background-100/30">
      {/* Header shimmer */}
      <div className="flex-shrink-0 flex items-center gap-3 px-4 py-2.5 bg-background-50 border-b border-background-200/60">
        <div className="flex items-center gap-3 flex-1 min-w-0 max-w-[700px] mx-auto w-full">
          <Shimmer className="w-10 h-10 rounded-full flex-shrink-0" />
          <div className="flex flex-col gap-1.5 flex-1 max-w-[180px]">
            <Shimmer className="h-3.5 rounded-full w-3/4" />
            <Shimmer className="h-2.5 rounded-full w-1/2" />
          </div>
        </div>
      </div>

      {/* Messages area shimmer */}
      <div className="flex-1 overflow-hidden px-4 py-3">
        <div className="max-w-[700px] mx-auto flex flex-col gap-2.5">
          {MOCK_BUBBLES.map((bubble, i) => (
            <div
              key={i}
              className={`flex ${bubble.side === "right" ? "justify-end" : "justify-start"}`}
            >
              <Shimmer
                className={`h-5 rounded-2xl`}
                style={{
                  width: `${bubble.w}%`,
                  borderRadius:
                    bubble.side === "right"
                      ? "16px 4px 16px 16px"
                      : "4px 16px 16px 16px",
                }}
              />
            </div>
          ))}

          {/* A couple of multi-line bubbles */}
          <div className="flex justify-start">
            <Shimmer
              className="h-12 rounded-2xl"
              style={{
                width: "62%",
                borderRadius: "4px 16px 16px 16px",
              }}
            />
          </div>
          <div className="flex justify-end">
            <Shimmer
              className="h-8 rounded-2xl"
              style={{
                width: "48%",
                borderRadius: "16px 4px 16px 16px",
              }}
            />
          </div>
        </div>
      </div>

      {/* Input area shimmer */}
      <div className="flex-shrink-0 px-4 py-2.5 bg-background-50 border-t border-background-200/60">
        <div className="max-w-[700px] mx-auto w-full">
          <Shimmer className="h-10 rounded-full w-full" />
        </div>
      </div>
    </div>
  );
}